import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../appCommon/AuthGuard/auth.guard';
import { SubMenues } from 'src/app/appCommon/Enums/enum';
import { UserProfileComponent } from './administration/components/user-profile/user-profile.component';
import {CardModule} from 'primeng/card';
import {RadioButtonModule} from 'primeng/radiobutton';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import {FieldsetModule} from 'primeng/fieldset';
import { RcaTreeComponent } from './Components/rca-tree/rca-tree.component';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { SliderModule } from 'primeng/slider';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { ToolbarModule } from 'primeng/toolbar';
import { RatingModule } from 'primeng/rating';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { InputMaskModule } from 'primeng/inputmask';
import { TooltipModule } from 'primeng/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from 'primeng/api';
import { ChartModule } from 'primeng/chart';
import { DividerModule } from 'primeng/divider';
import { PanelModule } from 'primeng/panel';
import { PasswordModule } from 'primeng/password';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { TabViewModule } from 'primeng/tabview';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TreeModule } from 'primeng/tree';
import {MatTreeModule} from '@angular/material/tree';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatSelectModule} from '@angular/material/select';
import { ToasterService } from 'src/app/appServices/ToasterService/toaster.service';
import { ElmahErrorComponent } from './Components/elmah-error/elmah-error.component';
import { caseInsensitiveMatcher } from 'src/app/appCommon/Pipes/LowerCaseUrlSerializer';



const routes: Routes = [
  { matcher:caseInsensitiveMatcher(SubMenues.DefaultPage) },
  { matcher:caseInsensitiveMatcher(SubMenues.ElmahError), component: ElmahErrorComponent },
  { matcher:caseInsensitiveMatcher(SubMenues.RCATree), component: RcaTreeComponent },
];

@NgModule({
  declarations: [
    UserProfileComponent,
    RcaTreeComponent,
    ElmahErrorComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    HttpClientModule,
    FormsModule,
    ButtonModule,
    FieldsetModule,
    ButtonModule,
    FormsModule,
    HttpClientModule,
    ToastModule,
    TableModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    InputTextModule,
    FileUploadModule,
    ToolbarModule,
    RatingModule,
    RadioButtonModule,
    InputNumberModule,
    ConfirmDialogModule,
    InputTextareaModule,
    CheckboxModule,
    ReactiveFormsModule,
    InputMaskModule,
    TooltipModule,
    SidebarModule,
    PasswordModule,
    DividerModule,
    SelectButtonModule,
    ToggleButtonModule,
    SharedModule,
    TabViewModule,
    MatTabsModule,
    ChartModule,
    PanelModule,
    ReactiveFormsModule,
    CardModule,
    TreeModule,
    MatTreeModule,
    MatIconModule,
    MatCheckboxModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatGridListModule,
    MatSelectModule,
  ],
  
    providers: [AuthGuard,RcaTreeComponent,ToasterService],
})
export class SettingsModule { }
